module.exports = __webpack_public_path__ + "static/media/Turnos.9d574da0.png";